import { put, select } from 'redux-saga/effects';
import { putEntities } from '../../redux/entities/actions';
import { getGallectionById } from '../selectors';
import type { Action } from 'redux-actions';
import type { ChangeGallectionDescriptionPayload } from '../actions';
import type { PapiGallection } from '@wix/da-papi-types';
import { normalizeGallection } from '../../redux/normalizr/helpers';

function* setGallectionDescription(action: Action<ChangeGallectionDescriptionPayload>) {
  const { folderId, description } = action.payload;
  const gallection: ReturnType<typeof getGallectionById> = yield select(
    getGallectionById,
    folderId
  );

  if (!gallection) {
    return;
  }

  const updatedGallection: PapiGallection = {
    ...gallection,
    richDescription: JSON.parse(description),
  };

  const entities = normalizeGallection(updatedGallection);
  yield put(putEntities({ entities }));
}

export default setGallectionDescription;
